module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAABAQMAAADgqcxbAAAAA1BMVEUxe1e7F9YXAAAACklEQVR4nGMAAgAABAABilw1LQAAAABJRU5ErkJggg=="